<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/yuce/wxxiangqing',title:'国外市场'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder"  >
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="预测编码">
                                <el-input v-model="formInline.id" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="国家名称">
                                <brselectlazy placeholder="请选择"
                                              category="YLCountry_agent"
                                              :v="formInline.country"
                                              v-model="formInline.country"
                                              clearable>
                                </brselectlazy>
                            </el-form-item>
                            <el-form-item label="产品编码">
                                <el-input v-model="formInline.proCode" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="产品型号">
                                <el-input v-model="formInline.proModel" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="　创建人名称">
                                <el-input v-model="formInline.cuname" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="审核状态">
                                <el-select v-model="formInline.forecastStatus" clearable placeholder="请选择">
                                    <el-option
                                            v-for="item in shStatus"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="审核通过时间" prop="passDate" style="width: 50%;">
                                <el-date-picker
                                        v-model="formInline.passbegin"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                                <span class="w-time-to">至</span>
                                <el-date-picker
                                        v-model="formInline.passend"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="型号经理是否审批">
                                <el-select v-model="formInline.isXhsp"
                                           placeholder="请选择"
                                           clearable>
                                    <el-option label="是" value="1"></el-option>
                                    <el-option label="否" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="自产/OEM">
                                <el-select v-model="formInline.protype"
                                           placeholder="请选择"
                                           clearable>
                                    <el-option label="自产" value="自产"></el-option>
                                    <el-option label="OEM" value="OEM"></el-option>
                                </el-select>
                            </el-form-item>
                          <el-form-item label="产地" >
                            <brselect category="factory" :v="formInline.chandidata" :showcode="true"
                                      v-model="formInline.chandidata" :multiple="true" :collapse-tags="true" clearable></brselect>
                          </el-form-item>
                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                                <el-button v-auth="'xzycan'" class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createdict">新增预测</el-button>
                                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="subTo" :disabled="disabled">确认提交</el-button>
                                <!--<el-button style="margin-right: 0.2rem;" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
                            border
                            max-height="500"
                            @selection-change="handleSelectionOrderChange"
                            style="width: 100%">
                        <el-table-column type="selection" width="40" align="center"></el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="id"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="预测编码">
                            <template slot-scope="scope">
                                <span>{{scope.row.id}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="country"
                                width="90"
                                :show-overflow-tooltip="true"
                                label="国家名称">
                            <template slot-scope="scope">
                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="area"
                                width="90"
                                :show-overflow-tooltip="true"
                                label="区域">
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                width="140"
                                :show-overflow-tooltip="true"
                                label="型号">
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                width="90"
                                :show-overflow-tooltip="true"
                                label="产地">
                        </el-table-column>
                        <el-table-column
                                prop="oemDesc"
                                width="140"
                                :show-overflow-tooltip="true"
                                label="规格型号">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="产品编码">
                        </el-table-column>
                        <el-table-column
                                prop="protype"
                                width="90"
                                label="型号属性"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                width="60"
                                :show-overflow-tooltip="true"
                                label="数量">
                        </el-table-column>
                        <el-table-column
                                prop="useNumber"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="可录单数量">
                            <template slot-scope="scope">
                                <span v-if="scope.row.forecastStatus == 3 || (scope.row.isSpecific == 2 && scope.row.isReformStock == '1' && scope.row.isXhsp == '1')">{{scope.row.useNumber}}</span>
                                <span v-else>0</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="forecastStatus"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="预测状态">
                            <template slot-scope="scope">
                                <dictname category="yuce_zhuangt"  :v="scope.row.forecastStatus"/>
                            </template>
                        </el-table-column>
                        <!--<el-table-column-->
                                <!--prop="warehouse"-->
                                <!--width="80"-->
                                <!--:show-overflow-tooltip="true"-->
                                <!--label="库龄">-->
                        <!--</el-table-column>-->
                        <!--<el-table-column-->
                                <!--prop="stockStatus"-->
                                <!--width="90"-->
                                <!--label="库存状态">-->
                            <!--<template slot-scope="scope">-->
                                <!--<dictname category="kucun_status"  :v="scope.row.stockStatus"/>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column
                                prop="isSpecific"
                                width="110"
                                :show-overflow-tooltip="true"
                                label="常规或改制">
                            <template slot-scope="scope">
                                <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReq"
                                :show-overflow-tooltip="true"
                                min-width="180"
                                label="改制目录">
                            <template slot-scope="scope">
                                <div style="text-align: left;">{{scope.row.specificReq}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificReform"
                                :show-overflow-tooltip="true"
                                min-width="180"
                                label="改制要求">
                            <template slot-scope="scope">
                                <div style="text-align: left;">{{scope.row.specificReform}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specificRemark"
                                :show-overflow-tooltip="true"
                                min-width="180"
                                label="改制备注">
                            <template slot-scope="scope">
                                <div style="text-align: left;">{{scope.row.specificRemark}}</div>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop="reformPriceRmb"-->
                                         <!--:show-overflow-tooltip="true"-->
                                         <!--width="100" label="单台加价(元)">-->
                            <!--<template slot-scope="scope">-->
                                <!--<div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                        <el-table-column
                                prop="isReal"
                                :show-overflow-tooltip="true"
                                min-width="120"
                                label="是否实单">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isReal == 1 ||scope.row.isReal == '1'">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="cuname"
                        :show-overflow-tooltip="true"
                        min-width="120"
                        label="创建人">
                        </el-table-column>
                        <el-table-column
                                prop="dbrname"
                                :show-overflow-tooltip="true"
                                width="90"
                                label="待办人">
                        </el-table-column>
                        <el-table-column
                                prop="remark"
                                :show-overflow-tooltip="true"
                                min-width="180"
                                label="备注">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.remark}}
                                </div>
                            </template>
                        </el-table-column>
                        <!--<el-table-column-->
                                <!--prop="deliveryDate"-->
                                <!--width="110"-->
                                <!--:show-overflow-tooltip="true"-->
                                <!--label="预计交货期">-->
                        <!--</el-table-column>-->

                        <el-table-column
                                prop="isXhsp"
                                :show-overflow-tooltip="true"
                                min-width="120"
                                label="型号经理是否审批">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isXhsp == 1">是</span>
                                <span v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="passDate"
                                :show-overflow-tooltip="true"
                                min-width="180"
                                label="审核通过时间">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.passDate}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                width="220"
                                label="操作">
                            <template slot-scope="scope">
                                <div style="display: flex;align-items: center;justify-content: center;">
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            v-if="scope.row.spId && scope.row.spId != ''"
                                            style="margin-left: 0;"
                                            @click="genzongLiuch(scope.row)">
                                        跟踪审批
                                    </el-button>
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            v-if="userCode == scope.row.cucode && scope.row.forecastStatus === 1"
                                            style="margin-left: 0;"
                                            @click="updateOpen(scope.row)">
                                        修改
                                    </el-button>
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            v-if="userCode == scope.row.cucode && scope.row.forecastStatus === 4 && !ksFlag"
                                            style="margin-left: 0;"
                                            @click="resubmitOpen(scope.row)">
                                        提报
                                    </el-button>
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            style="margin-left: 0;"
                                            @click="checkOpen(scope.row)">
                                        查看
                                    </el-button>
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            v-if="userCode == scope.row.cucode && (scope.row.forecastStatus === 1 || scope.row.forecastStatus === 4)"
                                            style="margin-left: 0;"
                                            @click="del(scope.row.id)">
                                        删除
                                    </el-button>
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            v-if="userCode == scope.row.cucode && scope.row.forecastStatus === 2 && !ksFlag"
                                            style="margin-left: 0;"
                                            @click="delVoid(scope.row.id)">
                                        撤回
                                    </el-button>
                                    <el-button
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn"
                                            v-if="scope.row.isSpecific == 2 && !ksFlag"
                                            @click="printDetail(scope.row.id)">
                                        导出明细
                                    </el-button>
                                    <el-button
                                        size="small" class="h-tableLink h-btn"
                                        v-if="scope.row.forecastStatus === 3 && scope.row.factory == '1R60'  && (ksFlag || isAdmin) && scope.row.useNumber === 0&& scope.row.isReceive === 0"
                                        style="margin-left: 0;"
                                        @click="arrive(scope.row.id)">
                                    去发货
                                </el-button>
                                    <el-button
                                            size="small" class="h-tableLink h-btn"
                                            v-if="scope.row.forecastStatus === 3 && scope.row.factory == '1R60' && (ksFlag || isAdmin) && scope.row.isReceive === 1"
                                            style="margin-left: 0;"
                                    >
                                        已发货
                                    </el-button>
                                    <!--<el-button-->
                                        <!--size="small" class="h-tableLink h-btn"-->
                                        <!--v-if="scope.row.warehouse && scope.row.warehouse < 120 && scope.row.useNumber > 0"-->
                                        <!--style="margin-left: 0;"-->
                                        <!--@click="releaseOpen(scope.row)">-->
                                    <!--预测释放-->
                                <!--</el-button>-->
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       style="padding: 0.1rem 0.20rem"  @click="downloadExcelDetailBatch">批量导出明细</el-button>
                        </div>
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="formInline" @query="query" />
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="h-txtCenter h-mrt60">-->
            <!--<el-button class="h-btn h-bBtn h-bgblueQ2" @click="renovate">返回</el-button>-->
            <!--</div>-->
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
        <div>
            <wxxiangqing-create ref="mychild" :order-number="orderNumber"></wxxiangqing-create>
            <wxxiangqing-update ref="mychild1" :order-number="orderNumber"></wxxiangqing-update>
            <wxxiangqing-check ref="mychild2" :order-number="orderNumber"></wxxiangqing-check>
            <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                             clsname="waiXiaoYuCeImportExcel"
                             :startrow="3" :extparams="bd" @callback="uploadExcelFilecallback"/>
            <el-dialog  title="预测释放数量" :close-on-click-modal="false" :visible.sync="dialogFormVisibleRelease" class="h-dialog4">
                <div class="h-formLine" style="width: 800px">
                    <el-form ref="form"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item label="可录单数量" class="h-elformWrap-2">
                            <el-input v-model="releaseData.useNumber" disabled placeholder="可用数量" class="h-tableInput">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="释放数量" class="h-elformWrap-2">
                            <el-input v-model="releaseData.releaseNum" placeholder="释放数量" class="h-tableInput">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="dialogFormVisibleRelease = false">取 消</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="submitRelease()">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'
    import wxxiangqingCreate from '../../../views/loud/yuce/wxxiangqing/wxxiangqingCreate'
    import wxxiangqingUpdate from '../../../views/loud/yuce/wxxiangqing/wxxiangqingUpdate'
    import wxxiangqingCheck from '../../../views/loud/yuce/wxxiangqing/wxxiangqingCheck'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel';
    import reformService from "../../../api/reform/reformService.js";

    export default {
        components: {wxxiangqingUpdate, wxxiangqingCreate,uploaddownexcel,wxxiangqingCheck},
        data() {
            return {
                userCode:"",
                orderNumber:'',
                shStatus: [{
                    value: '2',
                    label: '待审核'
                }, {
                    value: '3',
                    label: '审核通过'
                }, {
                    value: '4',
                    label: '审核驳回'
                }],
                formInline: {
                    id:'',
                    // createdDateLike: this.getyyyyMMdd(),
                    country:'',
                    proCode:'',
                    proModel:'',
                    createdDateLike: '',
                    forecastStatus: '',
                    isXhsp:'',
                    protype:'',
                    cuname: '',
                    passbegin:'',
                    passend:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    ids: []
                },
                tableData: [],
                submitData:[],
                userRole: [],
                a: '',
                instid: '',
                showhistory: false,
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    bid: '',
                },
                bd: {
                    bid: ''
                },
                saveData:{},
                uploaddownexcelflag:false,
                disabled:true,
                dialogFormVisibleRelease:false,
                releaseData:{
                    releaseNum:''
                },
                disabledVoid:false,
                tableSelectedList:[],
                ksFlag:false,
                isAdmin:false,
            }
        },
        mounted() {

        },
        created() {
            if (this.$store.getters.hasRole('swyl_waixiaogly')) {
                this.disabledVoid = true;
            }
            if (this.$store.getters.hasRole('swyl_admin')) {
                this.isAdmin = true;
            }
            if (this.$store.getters.hasRole('swyl_ks_ycsh')) {
                this.ksFlag = true;
            }
            this.userCode = this._user.usercode;
            this.query();
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/yuce/wxhuizong' && from.path == '/yuce/wxxiangqing'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
        methods: {
            del(id){
                this.$msg.confirm("确认删除?", () => {
                    ss.waixiao.deleteId(id).then(rd => {
                        this.query();
                    });
                })
            },
            //作废
            delVoid(id){
                this.$msg.confirm("确认撤回?", () => {
                    ss.waixiao.delById(id).then(rd => {
                        this.query();
                    });
                })
            },
            submitRelease(){
                this.$msg.confirm("确认释放?", () => {
                    ss.waixiao.release(this.releaseData).then(rd => {
                        this.query();
                        this.dialogFormVisibleRelease = false;
                    });
                })
            },
            releaseOpen(data){
                this.releaseData = data;
                this.dialogFormVisibleRelease = true;
            },
            handleSelectionOrderChange(data){
                this.tableSelectedList = data;
                this.submitData = [];
                for(var i=0;i<data.length;i++){
                    this.submitData.push(data[i]);
                }
                if(this.submitData.length>0){
                    for(var i=0;i<this.submitData.length;i++){
                        if(this.submitData[i].forecastStatus == 1 || this.submitData[i].forecastStatus == 4){
                            this.disabled = false;
                        }else {
                            this.disabled=true
                        }
                    }
                }else {
                    this.disabled=true
                }
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    if (this.submitData.length == 0) {
                        this.$msg.msge("数据不能为空,请填写数据!");
                    } else {
                        var f = true;
                        b:
                        if (f) {
                            var cou = this.$store.getters.dictlist("YLCountry_agent");
                            for (var i = 0; i < this.submitData.length; i++) {
                                for (var j = 0; j < cou.length; j++) {
                                    if (cou[j].name == this.submitData[i].country) {
                                        this.submitData[i].country = cou[j].code
                                    }
                                }
                                if (this.submitData[i].isSpecific == 2) {
                                    //循环设置
                                    this.submitData[i].specificReq = _.join(this.submitData[i].specific || [], ",");
                                } else {
                                    this.submitData[i].specificId = '';
                                    this.submitData[i].specificReq = '';
                                }
                                // if(!this.submitData[i].useMeg || this.submitData[i].useMeg == '' || this.submitData[i].useMeg == null){
                                //     this.$msg.msg("第"+(i+1)+"行，预测单未选择")
                                //     return
                                // }
                                this.submitData[i].prolist = [];
                                this.submitData[i].modelOpt = [];
                                this.submitData[i].codeOpt = [];

                                if (!this.submitData[i].specificType || this.submitData[i].specificType == '') {
                                    if (this.submitData[i].isSpecific == 1) {
                                        this.submitData[i].specificType = '1';
                                    } else {
                                        var index = this.submitData[i].specificId.indexOf("0");
                                        if(index == -1){
                                            this.submitData[i].specificType = '1';
                                        }else{
                                            this.submitData[i].specificType = '2';
                                        }
                                    }
                                }
                                if(!this.submitData[i].country || this.submitData[i].country == '' || this.submitData[i].country == null){
                                    return this.$msg.msge("预测单号："+this.submitData[i].id+",国家不能为空");
                                }
                                if(!this.submitData[i].area || this.submitData[i].area == '' || this.submitData[i].area == null){
                                    return this.$msg.msge("预测单号："+this.submitData[i].id+",区域不能为空");
                                }
                                if(!this.submitData[i].proCode || this.submitData[i].proCode == '' || this.submitData[i].proCode == null){
                                    return this.$msg.msge("预测单号："+this.submitData[i].id+",产品编码不能为空");
                                }
                                if(!this.submitData[i].proNumber || this.submitData[i].proNumber == '' || this.submitData[i].proNumber == null){
                                    return this.$msg.msge("预测单号："+this.submitData[i].id+",数量不能为空");
                                }
                                if(!this.submitData[i].isSpecific || this.submitData[i].isSpecific == '' || this.submitData[i].isSpecific == null){
                                    return this.$msg.msge("预测单号："+this.submitData[i].id+",常规或改制不能为空");
                                }
                                if(this.submitData[i].isSpecific == '2' || this.submitData[i].isSpecific == 2){
                                    if(!this.submitData[i].isReformStock || this.submitData[i].isReformStock == '' || this.submitData[i].isReformStock == null){
                                        return this.$msg.msge("预测单号："+this.submitData[i].id+",改制类型不能为空");
                                    }
                                }
                                if(!this.submitData[i].isReal || this.submitData[i].isReal == '' || this.submitData[i].isReal == null){
                                    return this.$msg.msge("预测单号："+this.submitData[i].id+",是否实单不能为空");
                                }
                                if(this.submitData[i].isReal == '1'){
                                    if(!this.submitData[i].deliveryDate || this.submitData[i].deliveryDate == '' || this.submitData[i].deliveryDate == null){
                                        return this.$msg.msge("预测单号："+this.submitData[i].id+",预计交货时间不能为空");
                                    }
                                }
                                if(this.submitData[i].isScheduling == '1' || this.submitData[i].isScheduling == '2'){
                                    if(!this.submitData[i].preId || this.submitData[i].preId == '' || this.submitData[i].preId == null){
                                        return this.$msg.msge("预测单号："+this.submitData[i].id+",预排单号不能为空");
                                    }
                                }
                                if(this.submitData[i].isOther == '1'){
                                    if(!this.submitData[i].useMeg || this.submitData[i].useMeg == '' || this.submitData[i].useMeg == null){
                                        return this.$msg.msge("预测单号："+this.submitData[i].id+",预测单号不能为空");
                                    }
                                }else if(this.submitData[i].isOther == '2'){
                                    if(!this.submitData[i].otherUseId || this.submitData[i].otherUseId == '' || this.submitData[i].otherUseId == null){
                                        return this.$msg.msge("预测单号："+this.submitData[i].id+",他人预测单号不能为空");
                                    }
                                }
                                if(this.submitData[i].protype == 'OEM') {
                                    if(!this.submitData[i].deliveryMethod || this.submitData[i].deliveryMethod == '' || this.submitData[i].deliveryMethod == null){
                                        return this.$msg.msge("预测单号："+this.submitData[i].id+",发货方式不能为空");
                                    }
                                }
                            }
                            ////ss.waixiao.subTo(this.submitData).then(rd => {
                            //// 新版提交
                            ss.waixiao.submitNewTo(this.submitData).then(rd => {
                                this.$msg.msgs(rd.msg);
                                this.submitData = [];
                                this.disabled = true;
                                this.query();
                            });
                        }
                    }
                })
            },
            uploadExcelFilecallback(rd) {
                this.uploaddownexcelflag=false;
                this.query();
            },
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            createdict(orderNumber){
                // orderNumber = true;
                // let self = this;
                // self.$refs["mychild"].isShowDia(orderNumber);

                this.$router.push({
                    path: '/yuce/createForcast',
                    // query: {ywid: data.id, instid: data.instid, taskstatus: '0', chongXinTiJiao: 1}
                })

            },
            resubmitOpen(data){
                this.$router.push({
                    path: '/yuce/yuceUpdate',
                    query: {ywid: data.id}
                })
            },
            updateOpen(data){
                this.$router.push({
                    path: '/yuce/yuceUpdate',
                    query: {ywid: data.id}
                })
            },
            // updateOpen(data){
            //     let self = this;
            //     self.$refs["mychild1"].isShowDia(data,true);
            //     self.saveData = data;
            // },
            checkOpen(data){
                this.$router.push({
                    path: '/yuce/yuceXiangqing',
                    query: {ywid: data.id,instid: data.spid}
                })
            },
            genzongLiuch(v) {
                console.log(v.spId);
                this.instid = v.spId;
                this.showhistory = true;
            },
            //明细导出
            exportExcel() {
                var idlist=[];
                this.tableSelectedList.forEach(element => {
                    // idlist.push(element.id);
                    this.formInline.ids.push(element.id);
                });
              // this.formInline.pageNo = '';
              // this.formInline.pageSize = '';
                updownfile.down("/api/swyl/v1/demo/bscForecastForeDetail/downloadExcel",this.formInline,"post",'data');
            },
            resetData() {
                this.formInline.id = '';
                this.formInline.cuname = '';
                this.formInline.country = '';
                this.formInline.createdDateLike = '';
                this.formInline.forecastStatus = '';
                this.formInline.proCode = '';
                this.formInline.proModel = '';
                this.formInline.isXhsp = '';
                this.formInline.passbegin = '';
                this.formInline.passend = '';
                this.formInline.protype = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.formInline.chandidata = '';
                this.query();
            },
            handleFilter() {
                ss.waixiao.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            query() {
                this.userRole = this._user.roles;
                this.userRole.forEach((item, index) => {
                    if (item.id == "swyl_admin" || item.id == "swyl_waixiaogly") {
                        this.a = 0;
                        return;
                    }
                    if (item.id == "swyl_xiaoshoujl_wx") {
                        this.a = 1;
                    }
                })
                ss.waixiao.page(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            renovate() {
                this.$router.push({path:"/yuce/wxhuizong"});
            },
            editData() {
                var bid = this.$route.query.id;
                this.$router.push({path:"/yuce/export_list", query: {bid: bid}});
            },
            printDetail(x) {
                ss.waixiao.checkDownload(x).then(rd => {
                    if(rd.f){
                        updownfile.down('/api/swyl/v1/demo/bscForecastForeDetail/downloadExcelDetail',{id:x},"get");
                    }
                })
            },
            downloadExcelDetailBatch(){
                var flag1 = false;
                var flag2 = false;
                var flag3 = false;
                this.tableSelectedList.forEach((item, index) => {
                    if(item.isXhsp != 1){
                        flag1 = true;
                        return;
                    }
                    if(item.protype == 'OEM'){
                        flag2 = true;
                        return;
                    }
                    if(item.isSpecific != 2){
                        flag3 = true;
                        return;
                    }
                })

                if(flag1){
                    this.$msg.msge("型号经理审核通过后的正常预测单才能导出明细,请重新选择!");
                    return;
                }

                if(flag2){
                    this.$msg.msge("自产预测单才能导出明细,请重新选择!");
                    return;
                }
                if(flag3){
                    this.$msg.msge("改制预测单才能导出明细,请重新选择!");
                    return;
                }
                var strids = _.join(_.map(this.tableSelectedList,"id"),",");
                this.$msg.confirm("确认批量导出明细?", () => {
                    updownfile.down('/api/swyl/v1/demo/bscForecastForeDetail/downloadExcelDetailBatch',{ids:strids},"post");

                });
            },
            arrive(id){
                this.$msg.confirm("确认已发货?", () => {
                    ss.waixiao.updateUseNumber(id).then(rd => {
                        this.query();
                    });
                })
            },
        }
    }
</script>
